import { Field, FieldProps } from 'formik';
import { FormattedMessage } from 'react-intl';
import { PaloField } from '@synergy/components-palo';
import { PoolNumberTextfield } from '@synergy/components-next';
import { ReactElement } from 'react';

import { PaloPositionEditModal } from '../../../../../common/components/palo/palo-position-edit-modal';

interface PositionEditModalProps {
    showPositionEditModal: boolean;
    onModalClose: () => void;
    positionIndex?: number;
    readonly?: boolean;
    currency: string;
    onDuplicate?: () => void;
    onInsertAbove?: () => void;
    onInsertBelow?: () => void;
    onDelete?: () => void;
}

/** One order position, in the dialog every document shares (#2208). */
export const PositionEditModal = (props: PositionEditModalProps): ReactElement => {
    const {
        showPositionEditModal,
        onModalClose,
        positionIndex,
        readonly,
        currency,
        onDuplicate,
        onInsertAbove,
        onInsertBelow,
        onDelete,
    } = props;

    return (
        <PaloPositionEditModal
            open={showPositionEditModal}
            index={positionIndex}
            readonly={readonly}
            currency={currency}
            /* The order carries the tax on the position itself; the invoice
               picks it from its counter account. */
            extraFields={prefix => (
                <PaloField label={<FormattedMessage id="app.table.column.tax" />} name={`${prefix}.tax`}>
                    <Field name={`${prefix}.tax`}>
                        {({ field }: FieldProps<number>) => (
                            <PoolNumberTextfield
                                minDecimalScale={2}
                                {...field}
                                type="dense"
                                readonly={readonly}
                                suffix=" %"
                                textAlign="right"
                                fullWidth={true}
                            />
                        )}
                    </Field>
                </PaloField>
            )}
            onDuplicate={onDuplicate}
            onInsertAbove={onInsertAbove}
            onInsertBelow={onInsertBelow}
            onDelete={onDelete}
            onClose={onModalClose}
        />
    );
};
